import type {
  DSLContext,
  DSLReadRequest,
  DSLReadResponse,
} from '@commenda/types/src/commenda-os-dsl';
import { fetcher } from '@commenda/utils';

import { sanitizeDSLContext } from './context';

/**
 * Like readCommendaOS, but a failed read throws instead of returning null, so a caller can tell
 * "the read failed" apart from "the field has no value".
 */
export async function readCommendaOSOrThrow<T = unknown>(
  path: string,
  context: DSLContext,
  shareToken: string | undefined
): Promise<T | null> {
  const response = await fetcher('dsl/read', {
    method: 'POST',
    body: { path, context: sanitizeDSLContext(context) } as DSLReadRequest,
    shareToken,
  });
  const jsonData = (await response.json()) as DSLReadResponse<T>;
  if (!response.ok) {
    throw new Error(jsonData?.message || 'Failed to read from DSL');
  }
  return jsonData.data ?? null;
}
